export default "__VITE_ASSET__CCPuMTE$__"